<template>
  <main class="main shop_priorConsent" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="pri_top">
        <div class="pri_title">
          사전승낙서란?
        </div>
        <div class="pri_txt">
          <div>
            국가에서 통신 시장의 건전한 유통질서 확립을 위해 만든 유무선 결합
            상품을 취급하는 판매점을 심사항목에 따라 사전 승낙을 받는
            제도입니다.
          </div>
        </div>
      </div>
      <div class="pri_con">
        <div class="con_title">
          사전승낙서 보기
        </div>
        <div class="con_list_wrap">
          <div class="con_list">
            <div
              class="list_box"
              v-if="priorConsentList['certOffMobile'].value"
            >
              <div
                class="b_img"
                v-html="priorConsentList['certOffMobile'].value"
              ></div>
              <div class="b_txt">
                {{ priorConsentList['certOffMobile'].label }}
              </div>
            </div>
            <div class="list_box" v-if="priorConsentList['certOnMobile'].value">
              <div
                class="b_img"
                v-html="priorConsentList['certOnMobile'].value"
              ></div>
              <div class="b_txt">
                {{ priorConsentList['certOnMobile'].label }}
              </div>
            </div>
            <div
              class="list_box"
              v-if="priorConsentList['certOnInternet'].value"
            >
              <div
                class="b_img"
                v-html="priorConsentList['certOnInternet'].value"
              ></div>
              <div class="b_txt">
                {{ priorConsentList['certOnInternet'].label }}
              </div>
            </div>
            <div
              class="list_box"
              v-if="priorConsentList['certOffInternet'].value"
            >
              <div
                class="b_img"
                v-html="priorConsentList['certOffInternet'].value"
              ></div>
              <div class="b_txt">
                {{ priorConsentList['certOffInternet'].label }}
              </div>
            </div>
            <div class="list_box" v-if="priorConsentList['certAgency'].value">
              <div
                class="b_img"
                v-html="priorConsentList['certAgency'].value"
              ></div>
              <div class="b_txt">
                {{ priorConsentList['certAgency'].label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { nativeBrowse, isApp } from '@common/lib/common/utils';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
export default {
  components: {},
  name: '',
  async created() {
    if (this.$route.query.id) {
      await this.getShopPriorConsent();
    }
    this.isCompleted = true;
  },
  data() {
    return {
      isCompleted: false,
      priorConsent: {
        pc1: [],
        pc2: [],
        pc3: [],
      },
      priorConsentList: {
        certOffMobile: { label: '무선 오프라인', value: '' },
        certOnMobile: { label: '무선 온라인', value: '' },
        certOffInternet: { label: '유선 오프라인', value: '' },
        certOnInternet: { label: '유선 온라인', value: '' },
        certAgency: { label: '대리점', value: '' },
      },
      priorConsentCheck: false,
    };
  },
  async mounted() {},
  computed: {
    ...shopMapGetters({
      shopPriorConsent: shopTypes.SHOP_PRIOR_CONSENT,
    }),
  },
  methods: {
    ...shopMapActions([shopTypes.FETCH_SHOP_PRIOR_CONSENT]),
    goPriorConsent(link) {
      if (isApp()) {
        nativeBrowse(link);
      } else {
        window.open(link, '_blank');
      }
    },
    async getShopPriorConsent() {
      const param = {
        id: this.$route.query.id,
      };

      await this[shopTypes.FETCH_SHOP_PRIOR_CONSENT](param).then(res => {
        console.log('resresresres');
        console.log(res);
        console.log(this.priorConsentList);
        this.priorConsentList['certOffMobile'].value = res.certOffMobile;
        this.priorConsentList['certOnMobile'].value = res.certOnMobile;
        this.priorConsentList['certOffInternet'].value = res.certOffInternet;
        this.priorConsentList['certOnInternet'].value = res.certOnInternet;
        this.priorConsentList.certAgency.value = res.certAgency;
        // 이미지 파일로 변환
        // for (const cert in this.shopPriorConsent) {
        //   if (cert !== 'storeId') {
        //     this.convertToHtml(cert, this.shopPriorConsent[cert]);
        //   }
        // }
      });

      // console.log(this.shopPriorConsent);

      // this.setPriorConsent(
      //   this.shopPriorConsent.certOffMobile,
      //   '오프라인 무선',
      // );
      // this.setPriorConsent(this.shopPriorConsent.certOnMobile, '온라인 무선');
      // this.setPriorConsent(
      //   this.shopPriorConsent.certOffInternet,
      //   '오프라인 유선',
      // );
      // this.setPriorConsent(this.shopPriorConsent.certOnInternet, '온라인 유선');
      // this.setPriorConsent(this.shopPriorConsent.certAgency, '대리점 인증마크');

      // console.log('this.priorConsent');
      // console.log(this.priorConsent);
    },
    stringToHTML(str) {
      var dom = document.createElement('div');
      dom.innerHTML = str;
      return dom;
    },
    // setPriorConsent(cert, name) {
    //   var elem_1 = this.stringToHTML(cert);

    //   if (elem_1.childNodes.length == 1) {
    //     for (let elem_2 of elem_1.childNodes) {
    //       if (elem_2.matches('a[href]')) {
    //         console.log(elem_2.childNodes[0].src);
    //         if (elem_2.childNodes.length == 1) {
    //           if (elem_2.childNodes[0].matches('img')) {
    //             if (this.priorConsent.pc1.length < 2) {
    //               this.priorConsent.pc1.push({
    //                 name: name,
    //                 link: elem_2.href,
    //                 image: elem_2.childNodes[0].src,
    //               });
    //             } else if (this.priorConsent.pc2.length < 2) {
    //               this.priorConsent.pc2.push({
    //                 name: name,
    //                 link: elem_2.href,
    //                 image: elem_2.childNodes[0].src,
    //               });
    //             } else {
    //               this.priorConsent.pc3.push({
    //                 name: name,
    //                 link: elem_2.href,
    //                 image: elem_2.childNodes[0].src,
    //               });
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // },
  },
};
</script>
